(function () {
  'use strict';
  var root = document.getElementById('nq-buybox');
  if (!root) return;
  function $(s) {
    return root.querySelector(s);
  }
  var variantInput = $('#nqVariantId');
  var qtyInput = $('#nqQty');
  var qty = 1;
  var variant = variantInput ? variantInput.value : null;

  /* gallery */
  var track = $('#galTrack');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('#galThumbs button'));
  if (track) {
    var slides = track.children.length;
    var setActive = function (i) {
      thumbs.forEach(function (b, j) {
        b.classList.toggle('on', j === i);
      });
      var gf = root.querySelector('.gal-flag');
      if (gf) gf.style.display = i === 0 ? '' : 'none';
    };
    track.addEventListener(
      'scroll',
      function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i >= 0 && i < slides) setActive(i);
      },
      { passive: true }
    );
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollTo({ left: parseInt(b.dataset.i, 10) * track.clientWidth, behavior: 'smooth' });
      });
    });
  }

  /* variant pick — simple swatches OR metal → letter matrix */
  function applyVariantEl(el) {
    if (!el || !el.dataset.variant) return;
    variant = el.dataset.variant;
    if (variantInput) variantInput.value = variant;
    var tp = $('#topPrice');
    var tw = $('#topWas');
    var to = $('#topOff');
    if (tp && el.dataset.price) tp.textContent = el.dataset.price;
    if (tw) {
      if (el.dataset.compare) {
        tw.textContent = el.dataset.compare;
        tw.style.display = '';
      } else {
        tw.style.display = 'none';
      }
    }
    if (to) {
      var now = parseFloat(String(el.dataset.price || '').replace(/[^\d.]/g, '')) || 0;
      var was = parseFloat(String(el.dataset.compare || '').replace(/[^\d.]/g, '')) || 0;
      if (was > now && now > 0) {
        to.textContent = '−' + Math.round(((was - now) / was) * 100) + '%';
        to.style.display = '';
      }
    }
    syncAtc();
  }

  function selectSwatch(s) {
    if (!s) return;
    root.querySelectorAll('.nqp-swatch').forEach(function (x) {
      x.classList.remove('on');
      x.setAttribute('aria-pressed', 'false');
    });
    s.classList.add('on');
    s.setAttribute('aria-pressed', 'true');
    applyVariantEl(s);
  }

  root.querySelectorAll('.nqp-swatch').forEach(function (s) {
    s.addEventListener('click', function () {
      selectSwatch(s);
    });
  });

  var matrix = root.querySelector('[data-nq-matrix]');
  if (matrix) {
    var letters = Array.prototype.slice.call(matrix.querySelectorAll('.nqp-letter'));
    var metals = Array.prototype.slice.call(matrix.querySelectorAll('.nqp-metal'));

    function setMetal(metal) {
      var prevLetter = null;
      var activeLetter = matrix.querySelector('.nqp-letter.on');
      if (activeLetter) prevLetter = activeLetter.dataset.letter;

      metals.forEach(function (m) {
        var on = m.dataset.metal === metal;
        m.classList.toggle('on', on);
        m.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var visible = [];
      letters.forEach(function (l) {
        var show = l.dataset.metal === metal;
        if (show) {
          l.removeAttribute('hidden');
          visible.push(l);
        } else {
          l.setAttribute('hidden', '');
          l.classList.remove('on');
          l.setAttribute('aria-pressed', 'false');
        }
      });

      var match =
        (prevLetter &&
          visible.filter(function (l) {
            return l.dataset.letter === prevLetter;
          })[0]) ||
        visible[0];
      if (match) selectLetter(match);
    }

    function selectLetter(btn) {
      if (!btn) return;
      letters.forEach(function (l) {
        var on = l === btn;
        l.classList.toggle('on', on);
        l.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyVariantEl(btn);
    }

    metals.forEach(function (m) {
      m.addEventListener('click', function () {
        setMetal(m.dataset.metal);
      });
    });
    letters.forEach(function (l) {
      l.addEventListener('click', function () {
        selectLetter(l);
      });
    });
  } else {
    // Size-only products (e.g. ring UK sizes L/N/P) — letters outside a metal matrix
    var sizeLetters = Array.prototype.slice.call(root.querySelectorAll('.nqp-letter'));
    sizeLetters.forEach(function (l) {
      l.addEventListener('click', function () {
        sizeLetters.forEach(function (x) {
          var on = x === l;
          x.classList.toggle('on', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyVariantEl(l);
      });
    });
  }

  function formId() {
    var form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
    // IMPORTANT: form.id collides with <input name="id"> (variant) — use getAttribute
    return form ? form.getAttribute('id') || '' : '';
  }

  var personalize = root.getAttribute('data-personalize') || 'none';

  function fieldHTML(i) {
    var form = formId();
    if (personalize === 'year') {
      var yLabel = i === 0 ? 'Enter your birth year' : 'Enter your birth year Piece ' + (i + 1);
      return (
        '<div class="namefield" data-i="' +
        i +
        '"><span class="nlabel">' +
        yLabel +
        '</span><div class="nrow"><input type="text" name="properties[Birth year' +
        (i === 0 ? '' : ' ' + (i + 1)) +
        ']" form="' +
        form +
        '" placeholder="e.g. 1996" autocomplete="off" maxlength="4" inputmode="numeric" required aria-required="true" aria-label="' +
        yLabel +
        '"></div></div>'
      );
    }
    if (personalize === 'name') {
      var nLabel = i === 0 ? 'Name' : 'Name Piece ' + (i + 1);
      return (
        '<div class="namefield" data-i="' +
        i +
        '"><span class="nlabel">' +
        nLabel +
        '</span><div class="nrow"><input type="text" name="properties[Name ' +
        (i + 1) +
        ']" form="' +
        form +
        '" placeholder="Type it exactly as you\'d like it…" autocomplete="off" maxlength="30" required aria-required="true" aria-label="' +
        nLabel +
        '"></div></div>'
      );
    }
    // arabic-name (default personalized)
    var labels = ['Name 1', 'Name 2', 'Name 3', 'Name 4'];
    return (
      '<div class="namefield" data-i="' +
      i +
      '"><span class="nlabel">' +
      labels[i] +
      ' — in English <em>we write the Arabic</em></span><div class="nrow"><input type="text" name="properties[Name ' +
      (i + 1) +
      ']" form="' +
      form +
      '" placeholder="e.g. Mariam, Nour…" autocomplete="off" maxlength="30" required aria-required="true" aria-label="' +
      labels[i] +
      ', in English"><div class="preview" data-clarity-unmask="true" aria-hidden="true"><span class="ph empty">Preview</span></div></div></div>'
    );
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /** Normalize English name keys for dictionary lookup (accents, apostrophes, hyphens). */
  function arNorm(raw) {
    var s = String(raw || '')
      .trim()
      .toLowerCase();
    try {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}
    s = s
      .replace(/[''\u2018\u2019`]/g, '')
      .replace(/[-–—_./\\]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return s;
  }

  function arLookup(raw) {
    var dict = window.NQ_AR;
    if (!dict) return null;
    var n = arNorm(raw);
    if (!n) return null;
    var keys = [n, n.replace(/\s+/g, ''), n.replace(/\s+/g, '-')];
    for (var i = 0; i < keys.length; i++) {
      if (dict[keys[i]]) return dict[keys[i]];
    }
    return null;
  }

  /**
   * Phonetic English → Arabic for names/phrases not in the curated dictionary.
   * Preview only — studio still verifies calligraphy before shipping.
   */
  function arTransliterate(raw) {
    var s = arNorm(raw);
    if (!s) return '';
    // Longest digraphs / trigraphs first
    var rules = [
      ['sch', 'ش'],
      ['tch', 'تش'],
      ['dge', 'ج'],
      ['igh', 'اي'],
      ['ough', 'و'],
      ['augh', 'و'],
      ['tion', 'شن'],
      ['sion', 'جن'],
      ['ph', 'ف'],
      ['th', 'ث'],
      ['kh', 'خ'],
      ['gh', 'غ'],
      ['ch', 'ش'],
      ['sh', 'ش'],
      ['zh', 'ج'],
      ['dh', 'ذ'],
      ['aa', 'ا'],
      ['ee', 'ي'],
      ['ii', 'ي'],
      ['oo', 'و'],
      ['uu', 'و'],
      ['ay', 'اي'],
      ['ai', 'اي'],
      ['ey', 'ي'],
      ['ei', 'ي'],
      ['oy', 'وي'],
      ['oi', 'وي'],
      ['ow', 'و'],
      ['aw', 'و'],
      ['au', 'و'],
      ['ou', 'و'],
      ['qu', 'قو'],
      ['ck', 'ك'],
      ['ng', 'نج'],
      ['wh', 'و'],
      ['wr', 'ر'],
      ['kn', 'ن'],
      ['mb', 'م'],
      ['a', 'ا'],
      ['b', 'ب'],
      ['c', 'ك'],
      ['d', 'د'],
      ['e', 'ي'],
      ['f', 'ف'],
      ['g', 'ج'],
      ['h', 'ه'],
      ['i', 'ي'],
      ['j', 'ج'],
      ['k', 'ك'],
      ['l', 'ل'],
      ['m', 'م'],
      ['n', 'ن'],
      ['o', 'و'],
      ['p', 'ب'],
      ['q', 'ق'],
      ['r', 'ر'],
      ['s', 'س'],
      ['t', 'ت'],
      ['u', 'و'],
      ['v', 'ف'],
      ['w', 'و'],
      ['x', 'كس'],
      ['y', 'ي'],
      ['z', 'ز']
    ];
    var out = '';
    var i = 0;
    while (i < s.length) {
      if (s[i] === ' ') {
        out += ' ';
        i++;
        continue;
      }
      var matched = false;
      for (var r = 0; r < rules.length; r++) {
        var from = rules[r][0];
        var to = rules[r][1];
        if (s.slice(i, i + from.length) === from) {
          out += to;
          i += from.length;
          matched = true;
          break;
        }
      }
      if (!matched) i++; // skip unknown punctuation
    }
    return out.replace(/\s+/g, ' ').trim();
  }

  /** Resolve any English string → Arabic: dict first (word or full), else transliterate. */
  function arResolve(raw) {
    var full = arLookup(raw);
    if (full) return { ar: full, source: 'dict' };
    var n = arNorm(raw);
    if (!n) return null;
    // Already Arabic script
    if (/[\u0600-\u06FF]/.test(raw)) return { ar: String(raw).trim(), source: 'ar' };
    var parts = n.split(' ').filter(Boolean);
    if (!parts.length) return null;
    var arParts = [];
    var anyDict = false;
    var anyTx = false;
    for (var i = 0; i < parts.length; i++) {
      var hit = arLookup(parts[i]);
      if (hit) {
        arParts.push(hit);
        anyDict = true;
      } else {
        var tx = arTransliterate(parts[i]);
        if (tx) {
          arParts.push(tx);
          anyTx = true;
        }
      }
    }
    if (!arParts.length) return null;
    return { ar: arParts.join(' '), source: anyTx && !anyDict ? 'tx' : anyTx ? 'mixed' : 'dict' };
  }

  function renderPreview(input, prev) {
    if (!input || !prev) return;
    var raw = String(input.value || '')
      .trim()
      .replace(/[<>]/g, '');
    if (!raw) {
      prev.classList.remove('has-name');
      prev.innerHTML = '<span class="ph empty">Preview</span>';
      return;
    }
    var en = '<span class="en" data-clarity-unmask="true">' + escapeHtml(raw) + '</span>';
    prev.classList.add('has-name');
    if (/[\u0600-\u06FF]/.test(raw) && !/[A-Za-z]/.test(raw)) {
      prev.innerHTML = en + '<span class="ar" data-clarity-unmask="true" dir="rtl" lang="ar">' + escapeHtml(raw) + '</span>';
      return;
    }
    if (!window.NQ_AR) {
      // Dictionary still loading — still transliterate so preview is never blank
      var early = arTransliterate(raw);
      if (early) {
        prev.innerHTML =
          en + '<span class="ar" data-clarity-unmask="true" dir="rtl" lang="ar">' + escapeHtml(early) + '</span>';
      } else {
        prev.innerHTML = en + '<span class="ph hand">Writing…</span>';
      }
      if (typeof window.NQ_loadArNames === 'function') window.NQ_loadArNames();
      return;
    }
    var resolved = arResolve(raw);
    if (resolved && resolved.ar) {
      prev.innerHTML =
        en +
        '<span class="ar" data-clarity-unmask="true" dir="rtl" lang="ar">' +
        escapeHtml(resolved.ar) +
        '</span>';
      return;
    }
    prev.innerHTML = en + '<span class="ph hand">Handwritten Arabic</span>';
  }

  function refreshAllPreviews() {
    root.querySelectorAll('#nameFields .namefield').forEach(function (f) {
      renderPreview(f.querySelector('input'), f.querySelector('.preview'));
    });
  }
  window.NQ_refreshArPreviews = refreshAllPreviews;

  function bindPreviews() {
    if (personalize !== 'arabic-name') return;
    var form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
    root.querySelectorAll('#nameFields .namefield').forEach(function (f) {
      var input = f.querySelector('input');
      var prev = f.querySelector('.preview');
      if (!input || !prev) return;
      if (form) input.setAttribute('form', form.getAttribute('id') || '');
      input.setAttribute('required', 'required');
      input.setAttribute('aria-required', 'true');
      prev.setAttribute('data-clarity-unmask', 'true');
      input.oninput = function () {
        input.classList.remove('err');
        var ne = $('#nameErr');
        if (ne) ne.classList.remove('show');
        renderPreview(input, prev);
      };
      // Also re-render on paste / composition end
      input.onpaste = function () {
        setTimeout(function () {
          renderPreview(input, prev);
        }, 0);
      };
      input.addEventListener('compositionend', function () {
        renderPreview(input, prev);
      });
    });
  }
  bindPreviews();
  // If dict already loaded (cached), paint immediately
  if (window.NQ_AR) refreshAllPreviews();

  function syncAtc() {
    var btn = $('#atcBtn');
    var priceEl = root.querySelector('[data-tier-price="' + qty + '"]');
    var label = priceEl ? priceEl.textContent : $('#topPrice') && $('#topPrice').textContent;
    if (btn && label) btn.textContent = 'Add to Bag — ' + label;
    if (qtyInput) qtyInput.value = String(qty);
  }

  function syncTopPrice(n) {
    var tier = root.querySelector('.tier[data-qty="' + n + '"]');
    var nowEl = root.querySelector('[data-tier-price="' + n + '"]');
    var wasEl = tier && tier.querySelector('.tprice .w');
    var tp = $('#topPrice');
    var tw = $('#topWas');
    var to = $('#topOff');
    if (tp && nowEl) tp.textContent = nowEl.textContent.trim();
    if (tw) {
      if (wasEl && wasEl.textContent.trim()) {
        tw.textContent = wasEl.textContent.trim();
        tw.style.display = '';
      } else {
        tw.style.display = 'none';
      }
    }
    if (to && nowEl && wasEl) {
      var now = parseFloat(String(nowEl.textContent).replace(/[^\d.]/g, '')) || 0;
      var was = parseFloat(String(wasEl.textContent).replace(/[^\d.]/g, '')) || 0;
      if (was > now && now > 0) {
        to.textContent = '−' + Math.round(((was - now) / was) * 100) + '%';
        to.style.display = '';
      } else {
        to.style.display = 'none';
      }
    }
  }

  function setQty(n) {
    n = Math.max(1, Math.min(4, parseInt(n, 10) || 1));
    qty = n;
    var holder = $('#nameFields');
    if (holder && personalize !== 'none' && personalize !== 'wasl') {
      var values = Array.prototype.slice.call(holder.querySelectorAll('input')).map(function (i) {
        return i.value;
      });
      holder.innerHTML = '';
      for (var i = 0; i < n; i++) holder.insertAdjacentHTML('beforeend', fieldHTML(i));
      holder.querySelectorAll('input').forEach(function (inp, idx) {
        if (values[idx]) inp.value = values[idx];
      });
      bindPreviews();
      holder.querySelectorAll('input').forEach(function (inp) {
        inp.dispatchEvent(new Event('input'));
      });
    }
    syncTopPrice(n);
    syncAtc();
  }

  function pickTier(t) {
    if (!t) return;
    root.querySelectorAll('.tier').forEach(function (x) {
      x.classList.remove('on');
    });
    t.classList.add('on');
    var r = t.querySelector('input');
    if (r) r.checked = true;
    setQty(parseInt(t.dataset.qty, 10));
  }

  root.querySelectorAll('.tier').forEach(function (t) {
    t.addEventListener('click', function () {
      pickTier(t);
    });
    var radio = t.querySelector('input[type="radio"]');
    if (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) pickTier(t);
      });
    }
  });

  var activeTier = root.querySelector('.tier.on') || root.querySelector('.tier input:checked') && root.querySelector('.tier input:checked').closest('.tier');
  if (activeTier) setQty(parseInt(activeTier.dataset.qty, 10) || 1);

  var gift = $('#giftbox');
  var giftWrap = $('#giftboxAddon');
  if (gift && giftWrap) {
    gift.addEventListener('change', function () {
      giftWrap.classList.toggle('on', gift.checked);
    });
  }
  var giftVariantId = gift ? parseInt(gift.getAttribute('data-gift-variant'), 10) : 0;

  function missingNames() {
    return Array.prototype.slice
      .call(root.querySelectorAll('#nameFields input'))
      .filter(function (i) {
        return !i.value.trim();
      });
  }

  function blockIfMissingNames(e) {
    var bad = missingNames();
    if (!bad.length) return false;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    bad.forEach(function (i) {
      i.classList.add('err');
    });
    var ne = $('#nameErr');
    if (ne) {
      ne.textContent =
        personalize === 'year'
          ? 'Please enter the birth year.'
          : bad.length === 1
            ? 'Please enter the name — it’s what we engrave.'
            : 'Please enter every name — it’s what we engrave.';
      ne.classList.add('show');
    }
    bad[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    bad[0].focus({ preventScroll: true });
    return true;
  }

  var form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
  if (form) {
    form.addEventListener(
      'submit',
      function (e) {
        blockIfMissingNames(e);
      },
      true
    );
    /* Gift box addon: when ticked, add main item + gift box product in ONE /cart/add.js call.
       Registered on document (capture) BEFORE nq-cart-drawer.js loads, so this runs first and
       stops the drawer's single-item handler; `cart:build` then refreshes + opens the drawer. */
    document.addEventListener(
      'submit',
      function (e) {
        if (e.target !== form) return;
        if (!gift || !gift.checked || !giftVariantId) return;
        if (blockIfMissingNames(e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var fd = new FormData(form);
        var props = {};
        fd.forEach(function (v, k) {
          var m = /^properties\[(.+)\]$/.exec(k);
          if (m) props[m[1]] = v;
        });
        var items = [
          { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1, properties: props },
          { id: giftVariantId, quantity: 1 }
        ];
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:build'));
          })
          .catch(function () {
            form.submit();
          });
      },
      true
    );
  }
  var atcBtn = $('#atcBtn');
  if (atcBtn) {
    atcBtn.addEventListener(
      'click',
      function (e) {
        blockIfMissingNames(e);
      },
      true
    );
  }

  syncAtc();
})();
